import React, {Component} from 'react';
import _ from 'lodash';
import StateViewer from 'components/StateViewer';
import Api from 'util/Api';
import PatientForm from './_form';
import PatientConsent from './_consent';
import Loader from 'components/Loader';
import moment from 'moment-timezone';
import StyledSelect from 'components/StyledSelect';
import RadioToggle from 'components/RadioToggle';
import RespForm from './_rrsetting';
import Demographics from "../../../../components/patient-settings/Demographics";

class PatientEdit extends Component {
    constructor(props) {
        super(props);

        this.state = {
            current: {},
            pending: {},
            error_msg: "",
            saveChangesButtonText: 'Save Changes',
            lowErrorOptions: _.times(31),
            highErrorOptions: _.times(31),
            isLoading: true,
            availableRooms: [],
            patient: {},
            isSubmitting: false,
            requiredFieldClasses: {
                firstName: 'required',
                lastName: 'required',
                gender: 'required',
                dob: 'required',
            },
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleAtRiskChange = this.handleAtRiskChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSaveChanges = this.handleSaveChanges.bind(this);
        this.handleModalCancel = this.handleModalCancel.bind(this);
        this.handleModalConfirm = this.handleModalConfirm.bind(this);
        this.handleViewForm = this.handleViewForm.bind(this);
        this.validateRequired = this.validateRequired.bind(this);
        this.handleValidateCombo = this.handleValidateCombo.bind(this);
        this.showModal = this.showModal.bind(this);
        this.handleRangeChange = this.handleRangeChange.bind(this);
        this.handleBooleanChange = this.handleBooleanChange.bind(this);
        this.handleNavigateTo = this.handleNavigateTo.bind(this);
        this.handleResetDefaultVisits = this.handleResetDefaultVisits.bind(this);
        this.handleResetDefaultRespiration = this.handleResetDefaultRespiration.bind(this);
        this.handleResetDefaultBedExit = this.handleResetDefaultBedExit.bind(this);
        this.handleLowWarnToggle = this.handleLowWarnToggle.bind(this);
        this.handleHighWarnToggle = this.handleHighWarnToggle.bind(this);
        this.handleCancelChanges = this.handleCancelChanges.bind(this);
        this.handleBedExitDisabled = this.handleBedExitDisabled.bind(this);
        this.handlBedExit24Hours = this.handlBedExit24Hours.bind(this);
    }

    handleCancelChanges() {
        this.props.history.push(`/facilities/${this.props.match.params.facility}/sections/${this.props.match.params.section}/patients`, {message: ''});
    }

    showModal(name, action) {
        this.setState({
            isModalVisible: true,
            modalQuestion: name,
            modalConfirmAction: action
        });
    }

    componentDidMount() {
        Api.withAuth(this.props.auth).getPatient({...this.props.match.params, includeForms: true})
            .then((data) => {
                const loadedPatient = {
                    ...data,
                    forms: data.forms || [],
                };

                this.setState({patient: loadedPatient, originalPatient: _.cloneDeep(loadedPatient)});
                return Api.withAuth(this.props.auth).getBedsNoIndex(this.props.match.params);
            })
            .then((data) =>
                this.setState({
                    availableRooms: _(data)
                        .filter(({id, occupied}) => id === this.state.patient.bed || !occupied)
                        .sortBy('name')
                        .value(),
                    isLoading: false,
                })
            );
        Api.withAuth(this.props.auth).getSetting(this.props.match.params).then((data) => {
            console.log(data);
            this.setState({
                current: {
                    ...this.state.current,
                    name,
                    patient:this.props.match.params.id,
                    setting: data
                },
                pending: {
                    ...this.state.current,
                    name,
                    patient:this.props.match.params.id,
                    setting: data
                }
            });
        });
    }

    handleValidateCombo = () => {
        console.log(`${this.state.patient}`);
        return true;
    }

    validateRequired({target}) {
        if (_.includes(_.keys(this.state.requiredFieldClasses), target.name)) {
            this.setState({
                requiredFieldClasses: {
                    ...this.state.requiredFieldClasses,
                    [target.name]: `required ${_.isEmpty(target.value) ? 'invalid' : ''}`
                }
            });
        }
    }

    check_bedexitrange(start, end, timezone) {
        var stList=start.split(":");
        var endList=end.split(":");
        const stHr=parseInt(stList[0], 10);
        const stMn=parseInt(stList[1], 10);
        const endHr=parseInt(endList[0], 10);
        const endMn=parseInt(endList[1], 10);
        if(stHr > 23 || endHr > 23 || stMn > 59 || endMn > 59) {
            return false;
        }
        const tzNow = moment.tz(timezone);
        const tzTom = moment(tzNow);
        tzTom.add(1, "d");
        const dateStrToday = tzNow.format("YYYY MM DD");
        const dateStrTomo = tzTom.format("YYYY MM DD");
        var stMom = moment.tz(dateStrToday+" "+start, "YYYY MM DD HH:mm", true, timezone);
        var endMom = moment.tz(dateStrTomo+" "+end, "YYYY MM DD HH:mm", true, timezone);
        var diff = endMom.diff(stMom, "m");
        if(diff >= 1440) {
            return false;
        }
        return true;
    }

    handleSaveChanges() {
        this.setState({
            error_msg: "",
            isSubmitting: false
        });
        if (!this.check_bedexitrange(this.state.current.setting.bedexit.rangestart_timeofday, this.state.current.setting.bedexit.rangeend_timeofday, this.state.current.setting.bedexit.rangeend_timeofday)) {
            this.setState({
                error_msg: true
            });
            return true;
        }

        this.showModal('SAVE_CHANGES', () => {
            this.setState({
                isSubmitting: true,
                saveChangesButtonText: 'Saving...',
            });

            const {facility, section, room} = this.props.match.params;
            // Extract just the filename for the patients forms
            const patientToSave = {
                ...this.state.patient,
                forms: this.state.patient.forms.map((form) => form.filename),
            };

            this.setState({
                isLoading: true,
                saveChangesButtonText: 'Saving...'
            });

            console.log(this.state.current.setting);
            Api.withAuth(this.props.auth).setSetting({id: this.state.current.patient, setting: this.state.current.setting}).then((data) => {
                Api.withAuth(this.props.auth).editPatient({...this.props.match.params, patient: patientToSave})
                    .then((data2) => {
                        this.setState({
                            isSubmitting: false,
                            isLoading: false,
                            saveChangesButtonText: 'Saved!',
                        });
                        setTimeout(() => {
                            this.setState({
                                saveChangesButtonText: 'Save Changes'
                            });
                        }, 2000);
                        //this.props.history.push(`/facilities/${this.props.match.params.facility}/sections/${this.props.match.params.section}/patients`, {message: 'Updated resident'});
                    });
            });
        });
    }

    handleChange({target}) {
        const current = _.cloneDeep(this.state.current);
        _.set(current, target.name, target.value);
        let targetValue = target.value;
        this.setState({
            current: {
                ...current,
            }
        });

        if (target.type === 'checkbox') { targetValue = target.checked; }

        this.setState({
            patient: {
                ...this.state.patient,
                [target.name]: targetValue
            }
        }, () => this.setState({
            originalPatient: {
                ...this.state.originalPatient,
                forms: this.state.patient.forms,
            }
        }));
    }
    handleAtRiskChange({target}) {
        const current = _.cloneDeep(this.state.current);
        var targetValue = target.value;
        if(target.textContent !== '') {
            target.name = 'atRisk';
            _.set(current, "patient.atRisk", (target.textContent==="Off" ? true : false));
            targetValue = (target.textContent==="Off" ? true : false);

            this.setState({
                current: {
                    ...current,
                }
            });


            this.setState({
                patient: {
                    ...this.state.patient,
                    'atRisk': targetValue
                }
            }, () => this.setState({
                originalPatient: {
                    ...this.state.originalPatient,
                    forms: this.state.patient.forms,
                }
            }));
        }
    }

    handleRangeChange({target}) {
        const current = _.cloneDeep(this.state.current);
        _.set(current, target.name, Number(target.value));

        if (target.name.endsWith('_urgent')) {
            const coTarget = `${target.name.split('_urgent')[0]}`;

            if (_.get(this.state.current, coTarget) === _.get(this.state.current, target.name)) {
                _.set(current, coTarget, Number(target.value));
            }
        }

        if (target.name.endsWith('normal')) {
            console.log(Number(target.value));
            const highWarn = _.get(this.state, 'current.setting.rr.high');
            if (highWarn) {
                _.set(current, 'setting.rr.high', Number(target.value) + 1);
            } else {
                // _.set(current, 'setting.rr.high_urgent', Number(target.value) + 1);
            }
        }

        this.setState({
            current: {
                ...current,
            }
        });
    }

    handleBooleanChange({target}) {
        const value = JSON.parse(target.value);

        this.setState({
            pending: {
                ...this.state.pending,
                [target.name]: value,
            }
        });
    }

    handleNavigateTo(event, destination) {
        if (_.isEqual(this.state.current, this.state.pending)) {
            this.props.history.push(destination);
        } else {
            this.showModal('NAVIGATE', () => this.props.history.push(destination));
        }

        event.preventDefault();
        return false;
    }

    handleResetDefaultVisits() {
        const current = _.cloneDeep(this.state.current);
        this.showModal('RESET_VISITS', () => {
            _.set(current, 'setting.visit', this.state.pending.setting.visit);

            this.setState({
                current: {
                    ...current
                }
            });
        });
    }

    handleResetDefaultRespiration() {
        const current = _.cloneDeep(this.state.current);
        this.showModal('RESET_RESPIRATION', () => {
            _.set(current, 'setting.rr', this.state.pending.setting.rr);

            this.setState({
                current: {
                    ...current
                }
            });
        });
    }

    handleResetDefaultBedExit() {
        const current = _.cloneDeep(this.state.current);
        this.showModal('RESET_BEDEXIT', () => {
            _.set(current, 'setting.bedexit', this.state.pending.setting.bedexit);

            this.setState({
                current: {
                    ...current
                }
            });
        });
    }

    handleLowWarnToggle(target) {
        const current = _.cloneDeep(this.state.current);
        const lowError = _.get(this.state, 'current.setting.rr.low', 0);
        const lowErrorvery_low_warn_alert_time = _.get(this.state, 'current.setting.rr.low_warn_alert_time');
        const lowErrorvery_low_urgent_alert_time = _.get(this.state, 'current.setting.rr.low_urgent_alert_time');
        const lowErrorlow_warn_alert_time = _.get(this.state, 'current.setting.rr.low_warn_alert_time');
        const highErrorhigh_warn_alert_time = _.get(this.state, 'current.setting.rr.high_warn_alert_time');
        const highErrorvery_high_warn_alert_time = _.get(this.state, 'current.setting.rr.high_warn_alert_time');
        const highErrorvery_high_urgent_alert_time = _.get(this.state, 'current.setting.rr.high_urgent_alert_time');
        const normal = _.get(this.state, 'current.setting.rr.normal');
        const lowWarn = 0; //_.get(this.state, 'current.setting.rr.low');
        const highWarn = 0; //_.get(this.state, 'current.setting.rr.high');
        if (lowError === lowWarn) {
            if (lowError === highWarn - 2) {
                _.set(current, "setting.rr.low", highWarn - 2);
                _.set(current, "setting.rr.very_low", highWarn - 3);
            } else if (lowError === _.max(this.state.lowErrorOptions)) {
                _.set(current, "setting.rr.low", lowError);
                _.set(current, "setting.rr.very_low", lowError - 1);
            } else {
                _.set(current, "setting.rr.low", lowError + 1);
            }
        }

        // If we are switching this off the content value will be On
        // and we need to remove the setting rr low value
        if (target.currentTarget.textContent === "On"){
            _.unset(current, "setting.rr.low");
        } else {
            _.set(current, "setting.rr.low", lowError + 1);
        }
        this.setState({
            current: {
                ...current,
            }
        });
    }

    handlBedExit24Hours(target) {
        const current = _.cloneDeep(this.state.current);
        _.set(current, "setting.bedexit.allday", (target.currentTarget.textContent==="Off" ? true : false));

        this.setState({
            current: {
                ...current,
            }
        });
    }

    handleBedExitDisabled(target) {
        const current = _.cloneDeep(this.state.current);
        _.set(current, "setting.bedexit.active", (target.currentTarget.textContent==="Off" ? true : false));

        this.setState({
            current: {
                ...current,
            }
        });
    }

    handleHighWarnToggle(target) {
        const current = _.cloneDeep(this.state.current);
        const lowWarn = _.get(this.state, 'current.setting.rr.low');
        const highWarn = _.get(this.state, 'current.setting.rr.high');
        const highError = _.get(this.state, 'current.setting.rr.high_urgent');
        const normal = _.get(this.state, 'current.setting.rr.normal');

        if (highError === highWarn) {
            if (highError === lowWarn + 2) {
                _.set(current, "setting.rr.high", lowWarn + 2);
                _.set(current, "setting.rr.high_urgent", lowWarn + 3);
            } else if (highError === _.min(this.state.highErrorOptions)) {
                _.set(current, "setting.rr.high", highError);
                _.set(current, "setting.rr.high_urgent", highError + 1);
            } else {
                _.set(current, "setting.rr.high", highError - 1);
            }
        }

        // If we are switching this off the content value will be On
        // and we need to remove the setting rr high value
        if (target.currentTarget.textContent === "On"){
            _.unset(current, "setting.rr.high");
        } else {
            _.set(current, "setting.rr.high", parseInt(normal, 10) + 1);
        }
        this.setState({
            current: {
                ...current,
            }
        });
    }

    handleCancel() {
        this.setState({
            pending: {
                ...this.state.current
            }
        });


        const action = () => this.props.history.push(`/facilities/${this.props.match.params.facility}/sections/${this.props.match.params.section}/patients`);

        if (this.hasPendingChanges()) {
            this.setState({
                isModalVisible: true,
                modalQuestion: 'NAVIGATE',
                modalConfirmAction: action,
            });
        } else {
            action();
        }
    }

    handleModalCancel() {
        this.setState({
            isModalVisible: false,
            modalQuestion: null,
            modalConfirmAction: _.noop,
        });
    }

    handleModalConfirm() {
        const action = this.state.modalConfirmAction;

        this.setState({
            isModalVisible: false,
            modalQuestion: null,
            modalConfirmAction: _.noop,
        }, action);
    }

    handleViewForm({url, filename}) {
        this.setState({
            isModalVisible: true,
            modalQuestion: 'PREVIEW',
            modalConfirmAction: _.noop,
            modalFileName: filename,
            modalFileUrl: url,
        });
    }

    hasPendingChanges() {
        return !_.isEqual(this.state.patient, this.state.originalPatient);
    }

    render() {
        const {auth} = this.props;
        const {current, pending} = this.state;
        const demo = this.props.auth.isDemoUser();

        const roomName = this.state.current.name;
        const changesPending = !_.isEqual(this.state.current, this.state.pending);

        const patient = this.state.current.patient;

        // Fill an array with 5, 10, 15, ..., 90
        const visitSoonTimerOptions = _.fill(Array(12), null).map((o, i) => (i + 1) * 10);

        const rrWarningTimerOptions = _.fill(Array(6), null).map((o, i) => (i + 1) * 10);


        const requiredMinutes = _.get(this.state, 'current.setting.visit.require_visit');
        const soonMinutes = _.get(this.state, 'current.setting.visit.visit_soon');
        const lowError = _.get(this.state, 'current.setting.rr.low', 0);
        const lowErrorvery_low_warn_alert_time = _.get(this.state, 'current.setting.rr.low_warn_alert_time');
        const lowErrorvery_low_urgent_alert_time = _.get(this.state, 'current.setting.rr.low_urgent_alert_time');
        const lowErrorlow_warn_alert_time = _.get(this.state, 'current.setting.rr.low_warn_alert_time');
        const highErrorhigh_warn_alert_time = _.get(this.state, 'current.setting.rr.high_warn_alert_time');
        const highErrorvery_high_warn_alert_time = _.get(this.state, 'current.setting.rr.high_warn_alert_time');
        const highErrorvery_high_urgent_alert_time = _.get(this.state, 'current.setting.rr.high_urgent_alert_time');
        const normal = _.get(this.state, 'current.setting.rr.normal');
        const lowWarn = 0; //_.get(this.state, 'current.setting.rr.low');
        const highWarn = 0; //_.get(this.state, 'current.setting.rr.high');
        const highError = _.get(this.state, 'current.setting.rr.high_urgent');

        const bedExitMinutes = _.get(this.state, 'current.setting.bedexit.span');
        const bedExitFrom = _.get(this.state, 'current.setting.bedexit.rangestart_timeofday');
        const bedExitTo = _.get(this.state, 'current.setting.bedexit.rangeend_timeofday');
        const bedExit24Hours = _.get(this.state, 'current.setting.bedexit.allday');
        const bedExitDisabled = _.get(this.state, 'current.setting.bedexit.active');
        const {lowErrorOptions, highErrorOptions} = this.state;
        const lowWarnOptions = this.state.lowErrorOptions;
        const highWarnOptions = this.state.highErrorOptions;

        const nomalRange = lowError + 1;

        let modalText, modalHeader;
        let cancelButtonText = 'No, Cancel';
        let confirmButtonText = 'Yes';
        let modalCancelButtonText = 'No';
        let modalConfirmButtonText = 'Yes';
        switch (this.state.modalQuestion) {
        case 'NAVIGATE':
            modalHeader = 'Unsaved Changes';
            modalText = 'You currently have unsaved changes. Are you sure you want to discard your changes?';
            cancelButtonText = 'Cancel';
            confirmButtonText = 'Discard Changes';
            break;
        case 'RESET_VISITS':
            modalHeader = 'Return to Default';
            modalText = ['Are you sure you want to return the Visit Tracker settings back to the system default for ', <strong key='roomName'>{roomName}</strong>, '?'];
            confirmButtonText = 'Yes, Restore Default';
            break;
        case 'RESET_RESPIRATION':
            modalHeader = 'Return to Default';
            modalText = ['Are you sure you want to return the Respiration Range settings back to the system default for ', <strong key='roomName'>{roomName}</strong>, '?'];
            confirmButtonText = 'Yes, Restore Default';
            break;
        case 'RESET_BEDEXIT':
            modalHeader = 'Return to Default';
            modalText = ['Are you sure you want to return the Bed Exit settings back to the system default for ', <strong key='roomName'>{roomName}</strong>, '?'];
            confirmButtonText = 'Yes, Restore Default';
            break;
        case 'SAVE_CHANGES':
            modalHeader = 'Confirm Changes';
            modalText = ['Are you sure you want to save these changes to the settings of ', <strong key='roomName'>{roomName}</strong>, '?'];
            confirmButtonText = 'YES, SAVE CHANGES';
            break;
        default:
            break;
        }
        let modalStyle = {};
        modalHeader = 'Confirm';
        modalText = 'Are you sure?';
        modalCancelButtonText = 'No';
        modalConfirmButtonText = 'Yes';
        //const requiredMinutes = _.get(this.state, 'pending.thresholds.bedexit.requiredMinutes', _.get(this.props, 'auth.facilityDetails.thresholds.bedexit.requiredMinutes'));
        //const soonMinutes = 0;

        switch (this.state.modalQuestion) {
        case 'NAVIGATE':
            modalHeader = 'Unsaved Changes';
            modalText = 'You currently have unsaved changes. Are you sure you want to discard your changes?';
            modalCancelButtonText = 'Cancel';
            modalConfirmButtonText = 'Discard Changes';
            break;
        case 'PREVIEW':
            modalStyle = {width: '90%'};
            modalHeader = this.state.modalFileName;
            modalText = (
                <iframe title='Preview' className='form-preview' src={this.state.modalFileUrl} />
            );
            modalCancelButtonText = 'Close';
            modalConfirmButtonText = null;
            break;
        default:
            break;
        }

        const readyToSubmit = !this.state.isSubmitting && this.hasPendingChanges() &&
      !_(this.state.requiredFieldClasses)
          .keys()
          .map((field) => _.get(this.state.patient, field))
          .some(_.isEmpty);
        return (
            <div className='patient-edit'>
                {false && <StateViewer value={this.state} />}
                <div className='subnav fixed-top'>
                    <div className='container h-100'>
                        <div className='row d-flex align-items-center h-100'>
                            <h3 className='breadcrumb-link' onClick={this.handleCancel}>Residents</h3>
                            <span className='separator' />
                            <h3>Edit Resident</h3>
                        </div>
                    </div>
                </div>
                {this.state.isLoading &&
                    <Loader />
                }
                <div className='row'>
                    <div className='col-md-12'>
                        {/*<Demographics*/}
                        {/*    availableRooms={this.state.availableRooms}*/}
                        {/*    patient={this.state.patient}*/}
                        {/*    requiredFieldClasses={this.state.requiredFieldClasses}*/}
                        {/*    onChange={this.handleChange}*/}
                        {/*    onChangeAtRisk={this.handleAtRiskChange}*/}
                        {/*    onValidateRequired={this.validateRequired}*/}
                        {/*/>*/}
                        <div className='card patient-demographics'>
                            <div className='card-header'>
                                Demographics
                            </div>

                            <div className='card-body'>
                                <PatientForm
                                    availableRooms={this.state.availableRooms}
                                    patient={this.state.patient}
                                    requiredFieldClasses={this.state.requiredFieldClasses}
                                    onChange={this.handleChange}
                                    onChangeAtRisk={this.handleAtRiskChange}
                                    onValidateRequired={this.validateRequired}
                                    onValidateCombo={this.handleValidateCombo}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {false && <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header'>
                                Diagnosis
                            </div>

                            <div className='card-body'>
                                TBD
                            </div>
                        </div>
                    </div>
                </div>
                }

                <div className='room-settings'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='card'>
                                <div className='card-header'>
                                    Visit Tracker
                                </div>
                                <div className='card-body px-0 py-0 bed-exit'>
                                    <section>
                                        <div className="row">
                                            <div className="col-md-8">
                                                <label>
                                                    <div>
                                                        Required Visit Timer
                                                        <small>
                                                            This room <strong>must be visited</strong> every:
                                                        </small>
                                                    </div>
                                                </label>
                                            </div>
                                            <div className="col-md-4">
                                                <StyledSelect
                                                    className='form-control'
                                                    name='setting.visit.require_visit'
                                                    value={requiredMinutes}
                                                    onChange={this.handleChange} >
                                                    <option value={15}>15 Minutes</option>
                                                    <option value={30}>30 Minutes</option>
                                                    <option value={60}>1 Hour</option>
                                                    <option value={120}>2 Hours</option>
                                                    <option value={180}>3 Hours</option>
                                                    <option value={240}>4 Hours</option>
                                                    <option value={300}>5 Hours</option>
                                                    <option value={360}>6 Hours</option>
                                                </StyledSelect>
                                            </div>
                                        </div>
                                    </section>

                                    <section>
                                        <div className="row">
                                            <div className="col-md-8">
                                                <label>
                                                    <div>
                                                        Visit Soon Timer
                                                        <small>
                                                            Choose the amount of minutes before the Required Visit that the <strong>Visit Soon alert</strong> will be triggered.
                                                        </small>
                                                    </div>
                                                </label>
                                            </div>
                                            <div className="col-md-4">
                                                <StyledSelect
                                                    className='form-control'
                                                    name='setting.visit.visit_soon'
                                                    value={soonMinutes}
                                                    onChange={this.handleChange} >
                                                    {visitSoonTimerOptions.map((time) => (
                                                        <option key={time} value={time}>{time} Minutes</option>
                                                    ))}
                                                </StyledSelect>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                                <div className='card-footer text-right'>
                                    <button className='btn btn-secondary' onClick={this.handleResetDefaultVisits}>Return to Default</button>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-header">
                                    Bed Exit
                                </div>
                                <div className='card-body px-0 py-0 bed-exit'>
                                    {(this.state.error_msg) &&
                                        <div className='alert alert-danger'>Bad Range for bed exit</div>}
                                    <section>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <label>
                                                    <div>
                                                        Bed Occupancy Time
                                                        <small>
                                                            Set the time range the <strong>resident will be in bed.</strong>
                                                        </small>
                                                    </div>
                                                </label>
                                            </div>
                                            <div className="col-md-6">
                                                All Day&nbsp;
                                                <RadioToggle value={bedExit24Hours} onClick={this.handlBedExit24Hours} />
                                            </div>
                                            <div className="col-md-6">
                                                <div style={{display:'flex', alignItems:'center'}}>
                                                    <StyledSelect
                                                        disabled={bedExit24Hours}
                                                        className='form-control'
                                                        name='setting.bedexit.rangestart_timeofday'
                                                        value={bedExitFrom}
                                                        onChange={this.handleChange} >
                                                        <option value={"00:00"}>12:00 AM</option>
                                                        <option value={"01:00"}>1:00 AM</option>
                                                        <option value={"02:00"}>2:00 AM</option>
                                                        <option value={"03:00"}>3:00 AM</option>
                                                        <option value={"04:00"}>4:00 AM</option>
                                                        <option value={"05:00"}>5:00 AM</option>
                                                        <option value={"06:00"}>6:00 AM</option>
                                                        <option value={"07:00"}>7:00 AM</option>
                                                        <option value={"08:00"}>8:00 AM</option>
                                                        <option value={"09:00"}>9:00 AM</option>
                                                        <option value={"10:00"}>10:00 AM</option>
                                                        <option value={"11:00"}>11:00 AM</option>
                                                        <option value={"12:00"}>12:00 PM</option>
                                                        <option value={"13:00"}>1:00 PM</option>
                                                        <option value={"14:00"}>2:00 PM</option>
                                                        <option value={"15:00"}>3:00 PM</option>
                                                        <option value={"16:00"}>4:00 PM</option>
                                                        <option value={"17:00"}>5:00 PM</option>
                                                        <option value={"18:00"}>6:00 PM</option>
                                                        <option value={"19:00"}>7:00 PM</option>
                                                        <option value={"20:00"}>8:00 PM</option>
                                                        <option value={"21:00"}>9:00 PM</option>
                                                        <option value={"22:00"}>10:00 PM</option>
                                                        <option value={"23:00"}>11:00 PM</option>
                                                    </StyledSelect>
                                                    -
                                                    <StyledSelect
                                                        disabled={bedExit24Hours}
                                                        className='form-control'
                                                        name='setting.bedexit.rangeend_timeofday'
                                                        value={bedExitTo}
                                                        onChange={this.handleChange} >
                                                        <option value={"00:00"}>12:00 AM</option>
                                                        <option value={"01:00"}>1:00 AM</option>
                                                        <option value={"02:00"}>2:00 AM</option>
                                                        <option value={"03:00"}>3:00 AM</option>
                                                        <option value={"04:00"}>4:00 AM</option>
                                                        <option value={"05:00"}>5:00 AM</option>
                                                        <option value={"06:00"}>6:00 AM</option>
                                                        <option value={"07:00"}>7:00 AM</option>
                                                        <option value={"08:00"}>8:00 AM</option>
                                                        <option value={"09:00"}>9:00 AM</option>
                                                        <option value={"10:00"}>10:00 AM</option>
                                                        <option value={"11:00"}>11:00 AM</option>
                                                        <option value={"12:00"}>12:00 PM</option>
                                                        <option value={"13:00"}>1:00 PM</option>
                                                        <option value={"14:00"}>2:00 PM</option>
                                                        <option value={"15:00"}>3:00 PM</option>
                                                        <option value={"16:00"}>4:00 PM</option>
                                                        <option value={"17:00"}>5:00 PM</option>
                                                        <option value={"18:00"}>6:00 PM</option>
                                                        <option value={"19:00"}>7:00 PM</option>
                                                        <option value={"20:00"}>8:00 PM</option>
                                                        <option value={"21:00"}>9:00 PM</option>
                                                        <option value={"22:00"}>10:00 PM</option>
                                                        <option value={"23:00"}>11:00 PM</option>
                                                    </StyledSelect>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    <section>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    Bed Exit Timer&nbsp;
                                                    <RadioToggle value={bedExitDisabled} onClick={this.handleBedExitDisabled} />
                                                </div>
                                            </div>
                                            <div className="col-md-8">
                                                <label>
                                                    <small>
                                                        Alert me if the resident has been <strong>out of the bed</strong> within the bed occupancy time for over
                                                    </small>
                                                </label>
                                            </div>
                                            <div className="col-md-4">
                                                <StyledSelect
                                                    disabled={!bedExitDisabled}
                                                    className='form-control'
                                                    name='setting.bedexit.span'
                                                    value={(bedExitMinutes)}
                                                    onChange={this.handleChange} >
                                                    <option value={120}>2 Minutes</option>
                                                    <option value={300}>5 Minutes</option>
                                                    <option value={600}>10 Minutes</option>
                                                    <option value={1200}>20 Minutes</option>
                                                    <option value={2400}>40 Minutes</option>
                                                    <option value={3600}>60 Minutes</option>
                                                </StyledSelect>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                                <div className='card-footer text-right'>
                                    <button className='btn btn-secondary' onClick={this.handleResetDefaultBedExit}>Return to Default</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/*<RespForm*/}
                    {/*    lowError={lowError}*/}
                    {/*    lowWarnOptions={lowWarnOptions}*/}
                    {/*    handleRangeChange={this.handleRangeChange}*/}
                    {/*    lowErrorOptions={lowErrorOptions}*/}
                    {/*    lowErrorvery_low_warn_alert_time={lowErrorvery_low_warn_alert_time}*/}
                    {/*    handleResetDefaultRespiration={this.handleResetDefaultRespiration}*/}
                    {/*    highErrorvery_high_urgent_alert_time={highErrorvery_high_urgent_alert_time}*/}
                    {/*    highErrorvery_high_warn_alert_time={highErrorvery_high_warn_alert_time}*/}
                    {/*    rrWarningTimerOptions={rrWarningTimerOptions}*/}
                    {/*    normal={normal}*/}
                    {/*    handleChange={this.handleChange}*/}
                    {/*    nomalRange={nomalRange}*/}
                    {/*    lowErrorvery_low_urgent_alert_time={lowErrorvery_low_urgent_alert_time}*/}
                    {/*    lowWarn={lowWarn}*/}
                    {/*/>*/}

                    <div className='rr-settings'>
                        <div className='card'>
                            <div className='card-header'>
                                Respiration Range
                            </div>
                            <section className='instructions'>
                                Set the ranges for Respiration. Please note that you may need to go back and adjust other levels if you make a change.
                            </section>
                            <div className='card-body'>
                                <div className="rr-setting-box">
                                    <div className="row">
                                        <div className="col-md-5 col-xs-12 rr-box">
                                            <div className="row">
                                                <div className="col-md-5">
                                                    <label className="d-flex align-items-center justify-content-center">
                                                        <div>
                                                            Low
                                                        </div>
                                                    </label>
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        <strong>0</strong>&nbsp; RR &mdash;
                                                        <StyledSelect
                                                            className='form-control'
                                                            name='setting.rr.low'
                                                            value={lowError}
                                                            onChange={this.handleRangeChange} >
                                                            {lowErrorOptions.map((i) => <option key={i} value={i} disabled={i > (normal-1)}>{i}&nbsp; RR</option>)}
                                                        </StyledSelect>
                                                    </div>
                                                </div>
                                                <div className="col-md-7">
                                                    <label className="d-flex align-items-center justify-content-center">
                                                        <div>
                                                            Alerts
                                                        </div>
                                                    </label>
                                                    <div className="row">
                                                        <div className="col-md-4 d-flex align-items-center justify-content-end">
                                                            <div className="form-group">
                                                                Warning
                                                            </div>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <div className="form-group">
                                                                <StyledSelect
                                                                    className='form-control'
                                                                    name='setting.rr.low_warn_alert_time'
                                                                    value={lowErrorvery_low_warn_alert_time}
                                                                    onChange={this.handleChange} >
                                                                    {rrWarningTimerOptions.map((time) => (
                                                                        <option key={time} value={time}>{time} Minutes</option>
                                                                    ))}
                                                                </StyledSelect>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 d-flex align-items-center justify-content-end">
                                                            <div className="form-group">
                                                                Urgent
                                                            </div>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <div className="form-group">
                                                                <StyledSelect
                                                                    className='form-control'
                                                                    name='setting.rr.low_urgent_alert_time'
                                                                    value={lowErrorvery_low_urgent_alert_time}
                                                                    onChange={this.handleChange} >
                                                                    <option value={60}>1 Hour</option>
                                                                    <option value={120}>2 Hours</option>
                                                                    <option value={180}>3 Hours</option>
                                                                    <option value={240}>4 Hours</option>
                                                                    <option value={300}>5 Hours</option>
                                                                    <option value={360}>6 Hours</option>
                                                                </StyledSelect>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-2 col-xs-12 rr-box brl">
                                            <label className="d-flex align-items-center justify-content-center">
                                                <div>
                                                    Normal
                                                </div>
                                            </label>
                                            <div className="d-flex align-items-center justify-content-center">
                                                <strong>{lowWarn ? lowWarn + 1 : lowError + 1}</strong>&nbsp; RR &mdash;
                                                <StyledSelect
                                                    className='form-control'
                                                    name='setting.rr.normal'
                                                    value={normal}
                                                    onChange={this.handleRangeChange} >
                                                    {lowWarnOptions.map((i) => (
                                                        <option key={i} value={i} disabled={i < nomalRange }>{i}&nbsp; RR</option>
                                                    ))}
                                                </StyledSelect>
                                            </div>
                                        </div>
                                        <div className="col-md-5 col-xs-12 rr-box">
                                            <div className="row">
                                                <div className="col-md-5">
                                                    <label className="d-flex align-items-center justify-content-center">
                                                        <div>
                                                            High
                                                        </div>
                                                    </label>
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        <strong>{parseInt(normal, 10) + 1}</strong>&nbsp; RR &nbsp;
                                                        <strong>and over</strong>
                                                    </div>
                                                </div>
                                                <div className="col-md-7">
                                                    <label className="d-flex align-items-center justify-content-center">
                                                        <div>
                                                            Alerts
                                                        </div>
                                                    </label>
                                                    <div className="row">
                                                        <div className="col-md-4 d-flex align-items-center justify-content-end">
                                                            <div className="form-group">
                                                                Warning
                                                            </div>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <div className="form-group">
                                                                <StyledSelect
                                                                    className='form-control'
                                                                    name='setting.rr.high_warn_alert_time'
                                                                    value={highErrorvery_high_warn_alert_time}
                                                                    onChange={this.handleChange} >
                                                                    {rrWarningTimerOptions.map((time) => (
                                                                        <option key={time} value={time}>{time} Minutes</option>
                                                                    ))}
                                                                </StyledSelect>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 d-flex align-items-center justify-content-end">
                                                            <div className="form-group">
                                                                Urgent
                                                            </div>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <div className="form-group">
                                                                <StyledSelect
                                                                    className='form-control'
                                                                    name='setting.rr.high_urgent_alert_time'
                                                                    value={highErrorvery_high_urgent_alert_time}
                                                                    onChange={this.handleChange} >
                                                                    <option value={60}>1 Hour</option>
                                                                    <option value={120}>2 Hours</option>
                                                                    <option value={180}>3 Hours</option>
                                                                    <option value={240}>4 Hours</option>
                                                                    <option value={300}>5 Hours</option>
                                                                    <option value={360}>6 Hours</option>
                                                                </StyledSelect>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='card-footer text-right'>
                                <button className='btn btn-secondary' onClick={this.handleResetDefaultRespiration}>Return to Default</button>
                            </div>
                        </div>
                    </div>

                    {_.indexOf(auth.currentUser.roles, 'user') === -1 &&
                        <div className='actions row'>
                            <div className='col-md-12 text-right'>
                                <button className='btn btn-secondary mx-2 px-5' onClick={this.handleCancelChanges} disabled={!changesPending}>Cancel
                                </button>
                                <button className='btn btn-primary mx-2 px-5' onClick={this.handleSaveChanges} disabled={!changesPending || !this.hasPendingChanges || demo}>
                                    {this.state.saveChangesButtonText}
                                    {demo && ' [DEMO]'}
                                </button>
                            </div>
                        </div>
                    }

                    {this.state.isModalVisible &&
                        <div>
                            <div className='popup-wrapper' onClick={this.handleModalCancel} role='dialog'>
                                <div className='popup' onClick={(e) => e.stopPropagation()}>
                                    <span className='close' onClick={this.handleModalCancel}>Close</span>

                                    <h1>{modalHeader}</h1>
                                    <p>{modalText}</p>

                                    <div className='actions text-center'>
                                        <button className='btn btn-secondary mx-2 px-5' onClick={this.handleModalCancel}>{cancelButtonText}</button>
                                        <button className='btn btn-primary mx-2 px-5' onClick={this.handleModalConfirm}>{confirmButtonText}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>

                {this.state.isModalVisible &&
          <div>
              <div className='popup-wrapper' onClick={this.handleModalCancel} role='dialog'>
                  <div className='popup' onClick={(e) => e.stopPropagation()} style={modalStyle}>
                      <span className='close' onClick={this.handleModalCancel}>Close</span>

                      <h1>{modalHeader}</h1>
                      <p>{modalText}</p>
                      <div className='actions text-center'>
                          <button className='btn btn-secondary mx-2 px-5' onClick={this.handleModalCancel}>{modalCancelButtonText}</button>
                          {modalConfirmButtonText &&
                                <button className='btn btn-primary mx-2 px-5' onClick={this.handleModalConfirm}>{modalConfirmButtonText}</button>
                          }
                      </div>
                  </div>
              </div>
          </div>
                }
            </div>
        );
    }
}

export default PatientEdit;
